var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSecurity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 20,
    viewBox: "0 0 15 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 8.14815H12.5926V5.92593C12.5926 2.66667 10.2963 0 7.40741 0C4.51852 0 2.22222 2.66667 2.22222 5.92593V8.14815H1.48148C0.666667 8.14815 0 8.81481 0 9.62963V18.5185C0 19.3333 0.666667 20 1.48148 20H13.3333C14.1481 20 14.8148 19.3333 14.8148 18.5185V9.62963C14.8148 8.81481 14.1481 8.14815 13.3333 8.14815ZM4.44444 6.66667C4.44444 6.14815 4.51852 5.62963 4.59259 5.18518C4.96296 3.48148 6.07407 2.22222 7.40741 2.22222C8.74074 2.22222 9.77778 3.48148 10.2222 5.18518C10.2963 5.62963 10.3704 6.14815 10.3704 6.66667V8.14815H4.44444V6.66667Z",
    fill: "#FF7900"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurity);
export default __webpack_public_path__ + "static/media/Security.36549946b1994ddbfc74398c625b9214.svg";
export { ForwardRef as ReactComponent };